'use client';

import { useApi } from '@prismo-io/core';
import useSWR from 'swr';
import useDebounceValue from '../../../helpers/use-debounce';
import { fetchDomains } from './fetch-domains';

type Props = {
  isOpen: boolean;
  term: string | null;
};

export const useDomainsAutocomplete = (props: Props) => {
  const { isOpen, term } = props;

  const termDebounced = useDebounceValue(term, 400);

  const { client } = useApi();

  return useSWR(
    () => (isOpen ? ['domains-autocomplete', termDebounced] : null),
    ([_, term]) => fetchDomains(client, term)
  );
};
